import { FactoryProvider, inject } from '@angular/core';
import { MessageService } from 'primeng/api';

export const provideParentMessageService = (): FactoryProvider => ({
	provide: MessageService,
	useFactory: () => inject(MessageService, { skipSelf: true })
});
